import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FlowRoutingModule } from "./flow-routing.module";
import { FlowComponent } from "./flow.component";
var FlowModule = /** @class */ (function () {
    function FlowModule() {
    }
    FlowModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, FormsModule, FlowRoutingModule],
                    declarations: [FlowComponent],
                    exports: [],
                    providers: []
                },] }
    ];
    return FlowModule;
}());
export { FlowModule };
//# sourceMappingURL=flow.module.js.map